import authoredClues from '../content/clues.json';
import { Clue } from '../types/discovery';

// Adapt the established unlock IDs without rewriting the author's clue collection.
const aliases: Record<string, string> = {
    disc_early_01: 'disc_home_moonTriple',
    disc_early_02: 'disc_leftLedge_hold',
    disc_mid_01: 'disc_media_redBook',
};
export const discoveryCatalog: Clue[] = [
    ...(authoredClues as Clue[]),
    ...Object.entries(aliases).flatMap(([id, source]) => {
        const clue = (authoredClues as Clue[]).find(c => c.id === source);
        return clue ? [{ ...clue, id }] : [];
    }),
    {
        id: 'disc_late_01', text: 'The last tower secret sleeps in your Diary. Find the golden wax seal and tap it. You have a full day to explore, whenever you begin.',
        realm: 'diary', difficulty: 3, cooldownDays: 0, timeWindow: null,
        targetHotspotId: 'diary_corner_seal',
        steps: [{ type: 'hotspot', realm: 'diary', hotspotId: 'diary_corner_seal', interaction: { kind: 'tap' } }],
    },
];
export const findClue = (id: string) => discoveryCatalog.find(c => c.id === id) || null;
